import styled from "styled-components";

export function EmptyLanguageIcon() {
    return <Icon>—</Icon>;
}

const Icon = styled.div`
    background-color: #d3d3d3;
    border-radius: 4px;
    color: white;
    padding: 0px;
    margin: 2px;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    width: 30px;
    color: gray;
`;